export const getToken = () => localStorage.getItem('token');  // or sessionStorage

export const isTokenValid = () => {
  const token = getToken();

  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));  // Decode JWT payload
    const expiration = payload.exp * 1000;  // Convert to milliseconds
    return expiration > Date.now();
  } catch (e) {
    return false;
  }
};

// Get the role from the token (assumes it's a JWT)
export const getRole = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role ? String(payload.role).toLowerCase() : null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const isAdmin = () => {
  return isTokenValid() && getRole() === 'admin';
};

export const isModerator = () => {
  return isTokenValid() && getRole() === 'moderator';
};

export const isUser = () => {
  return isTokenValid() && getRole() === 'user';
};

// Can manage clinical data (add/edit/delete individuals, families, CSV)
export const canManageData = () => {
  return isAdmin() || isModerator();
};

export const getID = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.userID || null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getEmail = () => {
  const token = getToken();
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.email) return String(payload.email).toLowerCase();
    } catch (error) {}
  }

  const stored = localStorage.getItem('user_email');
  return stored ? stored.toLowerCase() : null;
};

export const PUBLIC_PATHS = [
  '/txd/mapdata',
  '/txd/stats',
  '/txd/info',
  '/txd/doc',
];

export const isPublicPath = (pathname) => {
  if (!pathname) return false;
  return PUBLIC_PATHS.some(
    (p) => pathname === p || pathname.startsWith(p + '/')
  );
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user_email');
  window.location.href = '/txd/mapdata';
};